import { Table, Printer } from "@phosphor-icons/react";
import CustomTableView from "./CustomTableView";

export default function CustomTableCard({ table, onSave }) {
  return (
    <div className="mt-3 border border-amber-300 bg-amber-50/60 rounded-lg p-4" data-testid="custom-table-card">
      <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-amber-700 flex items-center gap-1.5">
        <Table size={14} weight="duotone" /> Tabel Custom AI
      </div>
      <div className="text-sm font-bold text-slate-900 mt-0.5" data-testid="custom-table-judul">
        {table.judul}
      </div>
      {table.ringkasan && <div className="text-xs text-slate-600 mt-0.5">{table.ringkasan}</div>}
      <div className="mt-3 bg-white rounded border border-slate-200 p-2 overflow-x-auto">
        <CustomTableView table={table} compact testIdPrefix="card-custom" />
      </div>
      {(table.keterangan || []).length > 0 && (
        <ul className="mt-2 text-[11px] text-slate-600 list-disc pl-4 space-y-0.5">
          {table.keterangan.map((k, i) => (
            <li key={i}>{k}</li>
          ))}
        </ul>
      )}
      <div className="mt-3 flex items-center justify-between gap-3 flex-wrap">
        <div className="text-xs text-slate-600">
          Perhitungan ini tidak memakai skema operasi standar — dicetak sebagai tabel custom pada kop surat.
        </div>
        <button
          onClick={onSave}
          className="bg-[#057A55] text-white px-3 py-2 rounded hover:bg-[#046148] text-xs font-bold inline-flex items-center gap-1.5"
          data-testid="custom-table-save"
        >
          <Printer size={14} weight="duotone" /> Simpan &amp; Cetak ke Kop Surat
        </button>
      </div>
    </div>
  );
}
